const totalGeneral = [
  {
    label: "Patient",
    total: 0,
    isIncrease: true,
    percentage: 0,
  },
  {
    label: "Sample",
    total: 0,
    isIncrease: false,
    percentage: 0,
  },
  {
    label: "Test",
    total: 0,
    isIncrease: false,
    percentage: 0,
  },
  {
    label: "EmergencyTest",
    total: 0,
    isIncrease: false,
    percentage: 0,
  },
]

export { totalGeneral }
